import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";

import asyncComponent from "util/asyncComponent";


const SocialApps = ({match}) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/profile`}/>
    <Route path={`${match.url}/profile`} component={asyncComponent(() => import('./Profile'))}/>
    <Route path={`${match.url}/wall`} component={asyncComponent(() => import('./Wall'))}/>
    <Route path={`${match.url}/accounts`} component={asyncComponent(() => import('./Accounts'))}/>
    <Route path={`${match.url}/application`} component={asyncComponent(() => import('./Application'))}/>
    <Route path={`${match.url}/devices`} component={asyncComponent(() => import('./Devices'))}/>
    <Route path={`${match.url}/inventory`} component={asyncComponent(() => import('./Inventory'))}/>
    <Route path={`${match.url}/device`} component={asyncComponent(() => import('./Device'))}/>
    <Route path={`${match.url}/minisites`} component={asyncComponent(() => import('./Minisites'))}/>
    <Route path={`${match.url}/customers`} component={asyncComponent(() => import('./Customers'))}/>
    <Route path={`${match.url}/minisite/:type/:minisiteId`} component={asyncComponent(() => import('./Minisite'))}/>
    <Route path={`${match.url}/dashboard`} component={asyncComponent(() => import('./Dashboard'))}/>
    <Route path={`${match.url}/results/:type/:minisiteId`} component={asyncComponent(() => import('./MinisiteResults'))}/>
    <Route path={`${match.url}/customer/:customerId`} component={asyncComponent(() => import('./Customer'))}/>
    <Route path={`${match.url}/attendances`} component={asyncComponent(() => import('./Attendances'))}/>
    <Route path={`${match.url}/admin`} component={asyncComponent(() => import('./Admin'))}/>
    <Route path={`${match.url}/external-clients`} component={asyncComponent(() => import('./ExternalClients'))}/>
    <Route path={`${match.url}/device-batches`} component={asyncComponent(() => import('./DeviceBatches'))}/>
    <Route path={`${match.url}/mesh-networks`} component={asyncComponent(() => import('./MeshNetworks'))}/>
    <Route path={`${match.url}/models`} component={asyncComponent(() => import('./Models'))}/>
    <Route path={`${match.url}/wifi-tests`} component={asyncComponent(() => import('./WifiTests'))}/>
  </Switch>
);

export default SocialApps;
